import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router';
import HttpsRedirect from 'react-https-redirect';

import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import swal from 'sweetalert2';
import 'url-search-params-polyfill';
import 'react-day-picker/lib/style.css';
import 'uppy/dist/uppy.min.css';
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';

import { obtenirNumeroServeur } from './App_Code/Utils';
import {
    ArrayFrom,
    ArrayFind,
    ArrayFindIndex,
    ArrayIncludes,
    StringIncludes,
    StringStartsWith,
} from './App_Code/Compat';
import PageException from './components/App/PageException';
import App from './components/App';
import {unregister} from './registerServiceWorker';

import reducers from './Reducers';
import Adherent from './components/Adherent';
import PageChargement from './components/App/PageChargement';
import PageDeconnexion from './components/App/PageDeconnexion';
import Maintenance from './components/App/Maintenance';

import './CSS/Adherent.css';
import './CSS/Algolia.css';
import './CSS/Badge.css';
import './CSS/Cercle.css';
import './CSS/Chargement.css';
import './CSS/Header.css';
import './CSS/PageAjoutCopro.css';
import './CSS/PageChargement.css';
import './CSS/Rater.css';
import './CSS/Style.css';
import './CSS/Ticket.css';
import './CSS/Uppy.css';
import './CSS/Uppy.css';
import './CSS/Votes.css';

const composeEnhancers =
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // eslint-disable-line no-underscore-dangle
        : compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

const getConfirmation = (message, callback) => {
    swal({
        title: 'Confirmation',
        html: message,
        type: 'warning',
        showCancelButton: true,
        focusCancel: true,
        confirmButtonText: 'Quitter la page',
        cancelButtonText: 'Rester sur la page',
    }).then((result) => {
        callback(result.value);
    });
};

/* Compatibilité avec les navigateurs qui n'implémentent pas les standards.
"Burn them all!" - Mad King */
if (!Array.from) window.Array.from = ArrayFrom;
if (!Array.prototype.find) window.Array.prototype.find = ArrayFind;
if (!Array.prototype.findIndex) window.Array.prototype.findIndex = ArrayFindIndex;
if (!Array.prototype.includes) window.Array.prototype.includes = ArrayIncludes;
if (!String.prototype.includes) window.String.prototype.includes = StringIncludes;
if (!String.prototype.startsWith) window.String.prototype.startsWith = StringStartsWith;

if (window === window.top) {
    const app = (
        <PageException>
            <div hidden>NumSrv : {obtenirNumeroServeur()}</div>
            <Provider store={store}>
                <BrowserRouter getUserConfirmation={getConfirmation}>
                    <Switch>
                        <Redirect from="/Login" to="/Connexion" />
                        <Redirect from="/Logout" to="/Deconnexion" />
                        <Redirect from="/Subscribe" to="/Inscription" />
                        <Route path="/Connexion" component={Adherent} />
                        <Route path="/Inscription" component={Adherent} />
                        <Route path="/MotdepasseOublie" component={Adherent} />
                        <Route path="/Ecourrier" component={Adherent} />
                        <Route path="/Chargement" component={PageChargement} />
                        <Route path="/Deconnexion" component={PageDeconnexion} />
                        <Route path="/Maintenance" component={Maintenance} />
                    
                        <Route path="/" component={App} />
                    </Switch>
                </BrowserRouter>
            </Provider>
        </PageException>
    );
/*     <Route path="/MFA" component={Adherent} /> */
    /* Mode normal */

    /* Si en ligne, redirection en https */
    const GMC_URL = process.env.NODE_ENV === 'production' ? window.env.API_URL : process.env.REACT_APP_API_URL;
    ReactDOM.render(
        <HttpsRedirect disabled={!GMC_URL.includes('gerer-ma-copro.fr')}>
            {app}
        </HttpsRedirect>,
        document.getElementById('root'),
    );
} else {
    /* Mode intégré */
    ReactDOM.render(<Adherent Iframe />, document.getElementById('root'));
}

//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js